import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {PropertyRpId} from "../../../types/ids";
import {View} from "../../km_app/types/View";
import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getAmplitudeOfferSourceProperties, isAmplitudeRpOffer} from "./get_amplitude_offer_source_properties";
import {getAmplitudePropertyItem} from "./get_amplitude_property_item";

type AmplitudeViewItemListProperty = IPropertyListItemDTO | IPropertyDetailDTO;

interface IGetAmplitudeViewItemListProductsParams {
    properties: AmplitudeViewItemListProperty[];
    sentPropertyRpIds?: Set<PropertyRpId>;
    viewType: View;
}

const shouldIncludeOfferSource = (viewType: View) => {
    return viewType === View.FAVORITE || viewType === View.COMPARATOR;
};

const withExternalOfferIdNulls = <T extends Record<string, unknown>>(property: AmplitudeViewItemListProperty, product: T) => {
    if (isAmplitudeRpOffer(property)) return product;

    // DSA-A-71: external offers always send item_id / property_id as NULL.
    return {
        ...product,
        item_id: null,
        property_id: null
    };
};

const getComparatorProductItem = (property: IPropertyListItemDTO, index: number, sentPropertyRpIds?: Set<PropertyRpId>): Record<string, unknown> => {
    const baseItem = getAmplitudePropertyItem({
        property,
        index,
        ...(sentPropertyRpIds ? {askOfferCtaVisible: getAskOfferCtaVisible(property, sentPropertyRpIds)} : {})
    });
    const standardDescription = "standard_description" in property.offer ? property.offer.standard_description : undefined;

    return withExternalOfferIdNulls(property, {
        ...baseItem,
        ...getAmplitudeOfferSourceProperties(property),
        additional_areas: property.additional_areas,
        available_from: property.offer.construction_date_range?.lower,
        built_year: property.built_date,
        construction_date: property.offer.construction_date_range,
        distance_from_region: property.offer.stats?.distance_from_region,
        facilities: property.offer.facilities,
        floors: property.floors,
        heating: standardDescription?.heating,
        kitchen: property.kitchen_type,
        parking_places: property.offer.parking_places,
        quarters: property.quarters,
        room_height_max: property.offer.stats?.ranges_height_max,
        room_height_min: property.offer.stats?.ranges_height_min,
        standard_types: standardDescription?.types
    });
};

const getAskOfferCtaVisible = (property: AmplitudeViewItemListProperty, sentPropertyRpIds: Set<PropertyRpId>) => {
    return !sentPropertyRpIds.has(property.rp_id) && !property.is_sold && !property.offer.limited_presentation;
};

export const getAmplitudeViewItemListProducts = ({
    properties,
    viewType,
    sentPropertyRpIds
}: IGetAmplitudeViewItemListProductsParams): Record<string, unknown>[] => {
    if (viewType === View.COMPARATOR) {
        return (properties as IPropertyListItemDTO[]).map((property, index) => getComparatorProductItem(property, index, sentPropertyRpIds));
    }

    return properties.map((property, index) => {
        const product = {
            ...getAmplitudePropertyItem({
                property,
                index,
                ...(sentPropertyRpIds ? {askOfferCtaVisible: getAskOfferCtaVisible(property, sentPropertyRpIds)} : {})
            }),
            ...(shouldIncludeOfferSource(viewType) ? getAmplitudeOfferSourceProperties(property) : {})
        };

        if (!shouldIncludeOfferSource(viewType)) return product;

        return withExternalOfferIdNulls(property, product);
    });
};
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {PropertyRpId} from "../../../types/ids";
import {View} from "../../km_app/types/View";
import {IPropertyListItemDTO} from "../../properties/types/IPropertyListItemDTO";
import {getAmplitudeOfferSourceProperties, isAmplitudeRpOffer} from "./get_amplitude_offer_source_properties";
import {getAmplitudePropertyItem} from "./get_amplitude_property_item";

type AmplitudeViewItemListProperty = IPropertyListItemDTO | IPropertyDetailDTO;

interface IGetAmplitudeViewItemListProductsParams {
    properties: AmplitudeViewItemListProperty[];
    sentPropertyRpIds?: Set<PropertyRpId>;
    viewType: View;
}

const shouldIncludeOfferSource = (viewType: View) => {
    return viewType === View.FAVORITE || viewType === View.COMPARATOR;
};

const withExternalOfferIdNulls = <T extends Record<string, unknown>>(property: AmplitudeViewItemListProperty, product: T) => {
    if (isAmplitudeRpOffer(property)) return product;

    // DSA-A-71: external offers always send item_id / property_id as NULL.
    return {
        ...product,
        item_id: null,
        property_id: null
    };
};

const getComparatorProductItem = (property: IPropertyListItemDTO, index: number, sentPropertyRpIds?: Set<PropertyRpId>): Record<string, unknown> => {
    const baseItem = getAmplitudePropertyItem({
        property,
        index,
        ...(sentPropertyRpIds ? {askOfferCtaVisible: getAskOfferCtaVisible(property, sentPropertyRpIds)} : {})
    });
    const standardDescription = "standard_description" in property.offer ? property.offer.standard_description : undefined;

    return withExternalOfferIdNulls(property, {
        ...baseItem,
        ...getAmplitudeOfferSourceProperties(property),
        additional_areas: property.additional_areas,
        available_from: property.offer.construction_date_range?.lower,
        built_year: property.built_date,
        construction_date: property.offer.construction_date_range,
        distance_from_region: property.offer.stats?.distance_from_region,
        facilities: property.offer.facilities,
        floors: property.floors,
        heating: standardDescription?.heating,
        kitchen: property.kitchen_type,
        parking_places: property.offer.parking_places,
        quarters: property.quarters,
        room_height_max: property.offer.stats?.ranges_height_max,
        room_height_min: property.offer.stats?.ranges_height_min,
        standard_types: standardDescription?.types
    });
};

const getAskOfferCtaVisible = (property: AmplitudeViewItemListProperty, sentPropertyRpIds: Set<PropertyRpId>) => {
    return !sentPropertyRpIds.has(property.rp_id) && !property.is_sold && !property.offer.limited_presentation;
};

export const getAmplitudeViewItemListProducts = ({
    properties,
    viewType,
    sentPropertyRpIds
}: IGetAmplitudeViewItemListProductsParams): Record<string, unknown>[] => {
    if (viewType === View.COMPARATOR) {
        return (properties as IPropertyListItemDTO[]).map((property, index) => getComparatorProductItem(property, index, sentPropertyRpIds));
    }

    return properties.map((property, index) => {
        const product = {
            ...getAmplitudePropertyItem({
                property,
                index,
                ...(sentPropertyRpIds ? {askOfferCtaVisible: getAskOfferCtaVisible(property, sentPropertyRpIds)} : {})
            }),
            ...(shouldIncludeOfferSource(viewType) ? getAmplitudeOfferSourceProperties(property) : {})
        };

        if (!shouldIncludeOfferSource(viewType)) return product;

        return withExternalOfferIdNulls(property, product);
    });
};
